import withQueryParams from "../../utils/withQueryParams";
import productPageBaseUri from "../../utils/productPageBaseUri";

class StockBranchesServiceClient {
  constructor(integrationService) {
    this._integrationService = integrationService;
  }

  fetchStockAvailabilityBranches = async (productCode, quantity, unitOfMeasure, location) => {
    const stockAvailabilityBranchesUri = withQueryParams(
      `${productPageBaseUri}api/products/${productCode}/stockAvailability/branches`,
      {
        requiredQuantity: quantity,
        unitOfMeasure: unitOfMeasure,
        address: location
      });

    return this._integrationService.read({
      url: stockAvailabilityBranchesUri,
      method: "GET",
      credentials: "include"
    });
  }
}

export default StockBranchesServiceClient;
